// Collection-Tag-09-June-2026
theme.MetafieldsFilter = (function() {
  var isAnimating = false;
  var popstateBound = false;

  var selectors = {
    filterNav: '[data-metafields-filter]',
    filterLink: '.metafields-filter',
    clearFilter: '[data-clear-filter]',
    filterStatus: '[data-filter-status]',
    filterStatusLabel: '[data-filter-status-label]',
    collectionGrid: '.collection-grid__wrapper',
    productGrid: '.collection-grid__wrapper .grid--uniform',
    productItem: '.grid-product[data-product-tags]',
    scrollTarget: '[data-scroll-to]',
    section: '[data-section-type="collection-grid"]',
    drawer: '[data-metafields-filter-drawer]',
    drawerOpen: '[data-metafields-filter-open]',
    drawerClose: '[data-metafields-filter-close]'
  };

  function MetafieldsFilter(nav) {
    this.nav = nav;
    this.sectionEl = nav.closest(selectors.section);
    this.sectionId = this.sectionEl && this.sectionEl.getAttribute('data-section-id');
    this.drawer = this.sectionEl && this.sectionEl.querySelector(selectors.drawer);
    this.openBtn = this.sectionEl && this.sectionEl.querySelector(selectors.drawerOpen);
    this.onEsc = this.onEsc.bind(this);
    this.bindEvents();
    this.applyFilterFromUrl();
    this.syncDrawerA11y(false);
  }

  MetafieldsFilter.prototype.bindEvents = function() {
    var self = this;
    var section = this.sectionEl;

    this.nav.querySelectorAll(selectors.filterLink).forEach(function(link) {
      if (link.classList.contains('metafields-filter--redirect')) {
        return;
      }
      link.addEventListener('click', self.onFilterClick.bind(self));
    });

    if (section) {
      section.querySelectorAll(selectors.clearFilter).forEach(function(button) {
        button.addEventListener('click', self.onClearClick.bind(self));
      });
    }

    if (this.openBtn) {
      this.openBtn.addEventListener('click', this.openDrawer.bind(this));
    }

    if (this.drawer) {
      this.drawer.querySelectorAll(selectors.drawerClose).forEach(function(button) {
        button.addEventListener('click', self.closeDrawer.bind(self));
      });
    }

    if (!popstateBound) {
      window.addEventListener('popstate', self.onPopState.bind(self));
      popstateBound = true;
    }
  };

  MetafieldsFilter.prototype.isSmallScreen = function() {
    return window.matchMedia('(max-width: 768px)').matches;
  };

  MetafieldsFilter.prototype.syncDrawerA11y = function(isOpen) {
    if (!this.drawer) {
      return;
    }

    if (!this.isSmallScreen()) {
      this.drawer.removeAttribute('aria-hidden');
      return;
    }

    this.drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  };

  MetafieldsFilter.prototype.openDrawer = function(evt) {
    if (evt) {
      evt.preventDefault();
    }

    if (!this.drawer || !this.isSmallScreen() || this.drawer.classList.contains('is-open')) {
      return;
    }

    this.drawer.classList.add('is-open');
    document.documentElement.classList.add('metafields-filter-drawer-open');
    this.syncDrawerA11y(true);

    if (this.openBtn) {
      this.openBtn.setAttribute('aria-expanded', 'true');
    }

    var closeBtn = this.drawer.querySelector(selectors.drawerClose + '[aria-label]');
    if (closeBtn) {
      closeBtn.focus();
    }

    document.addEventListener('keydown', this.onEsc);
  };

  MetafieldsFilter.prototype.closeDrawer = function(restoreFocus) {
    if (!this.drawer) {
      document.documentElement.classList.remove('metafields-filter-drawer-open');
      return;
    }

    var wasOpen = this.drawer.classList.contains('is-open');

    this.drawer.classList.remove('is-open');
    document.documentElement.classList.remove('metafields-filter-drawer-open');
    this.syncDrawerA11y(false);
    document.removeEventListener('keydown', this.onEsc);

    if (this.openBtn) {
      this.openBtn.setAttribute('aria-expanded', 'false');
      if (restoreFocus !== false && wasOpen && this.isSmallScreen()) {
        this.openBtn.focus();
      }
    }
  };

  MetafieldsFilter.prototype.onEsc = function(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) {
      this.closeDrawer();
    }
  };

  MetafieldsFilter.prototype.getCollectionUrl = function() {
    return this.nav.getAttribute('data-collection-url');
  };

  MetafieldsFilter.prototype.getTagHandleFromUrl = function(collectionUrl) {
    var pathname = window.location.pathname;
    var base = collectionUrl.replace(/\/$/, '');
    var prefix = base + '/';

    if (pathname.indexOf(prefix) !== 0) {
      return null;
    }

    var remainder = pathname.slice(prefix.length);

    if (!remainder) {
      return null;
    }

    return remainder.split('/')[0].split('+')[0];
  };

  MetafieldsFilter.prototype.findLinkByHandle = function(tagHandle) {
    if (!tagHandle) {
      return null;
    }

    var match = null;

    this.nav.querySelectorAll(selectors.filterLink).forEach(function(link) {
      if (link.classList.contains('metafields-filter--redirect')) {
        return;
      }
      if (link.getAttribute('data-filter') === tagHandle) {
        match = link;
      }
    });

    return match;
  };

  MetafieldsFilter.prototype.applyFilterFromUrl = function() {
    var collectionUrl = this.getCollectionUrl();
    var tagHandle = this.getTagHandleFromUrl(collectionUrl);
    var activeLink = this.findLinkByHandle(tagHandle);
    var statusEl = this.sectionEl && this.sectionEl.querySelector(selectors.filterStatus);

    this.nav.querySelectorAll(selectors.filterLink).forEach(function(link) {
      if (link.classList.contains('metafields-filter--redirect')) {
        return;
      }
      link.classList.remove('metafields-filter--active');
      link.setAttribute('aria-pressed', 'false');
    });

    if (this.openBtn) {
      this.openBtn.classList.toggle('btn--tertiary-active', Boolean(activeLink));
    }

    if (activeLink) {
      activeLink.classList.add('metafields-filter--active');
      activeLink.setAttribute('aria-pressed', 'true');

      var label = activeLink.getAttribute('data-filter-label') || activeLink.textContent.trim();
      var productTag = activeLink.getAttribute('data-product-tag');
      var template = this.nav.getAttribute('data-filtered-by-template') || 'Showing: __LABEL__';

      if (statusEl) {
        statusEl.hidden = false;
        var labelEl = statusEl.querySelector(selectors.filterStatusLabel);
        if (labelEl) {
          labelEl.textContent = template.replace('__LABEL__', label);
        }
      }

      this.applyProductFilter(productTag);
    } else {
      if (statusEl) {
        statusEl.hidden = true;
      }
      this.clearProductFilter();
    }
  };

  MetafieldsFilter.prototype.productHasTag = function(tagsString, productTag) {
    if (!tagsString || !productTag) {
      return false;
    }

    return tagsString.split(',').some(function(tag) {
      return tag.trim() === productTag;
    });
  };

  MetafieldsFilter.prototype.applyProductFilter = function(productTag) {
    var section = this.sectionEl;
    if (!section) {
      return;
    }

    var grid = section.querySelector(selectors.productGrid);
    var items = section.querySelectorAll(selectors.productItem);
    var visibleCount = 0;
    var emptyText = this.nav.getAttribute('data-empty-text') || 'Sorry, there are no products in this collection.';

    items.forEach(function(item) {
      var match = this.productHasTag(item.getAttribute('data-product-tags'), productTag);
      item.style.display = match ? '' : 'none';
      if (match) {
        visibleCount += 1;
      }
    }.bind(this));

    this.removeJsEmptyMessage();

    if (grid && visibleCount === 0 && !grid.querySelector('.metafields-filter__empty, [data-js-empty]')) {
      var emptyWrap = document.createElement('div');
      emptyWrap.className = 'grid__item metafields-filter__empty-wrap';
      emptyWrap.setAttribute('data-js-empty', '');
      emptyWrap.innerHTML = '<p class="metafields-filter__empty">' + emptyText + '</p>';
      grid.appendChild(emptyWrap);
    }

  };

  MetafieldsFilter.prototype.clearProductFilter = function() {
    var section = this.sectionEl;
    if (!section) {
      return;
    }

    section.querySelectorAll(selectors.productItem).forEach(function(item) {
      item.style.display = '';
    });

    this.removeJsEmptyMessage();
  };

  MetafieldsFilter.prototype.removeJsEmptyMessage = function() {
    var section = this.sectionEl;
    if (!section) {
      return;
    }

    section.querySelectorAll('[data-js-empty]').forEach(function(el) {
      el.remove();
    });
  };

  MetafieldsFilter.prototype.buildUrl = function(pathname, clearFilter) {
    var url = new URL(pathname, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function(value, key) {
      if (key === 'page') {
        return;
      }
      if (clearFilter && key === 'filter.p.tag') {
        return;
      }
      url.searchParams.append(key, value);
    });

    return url;
  };

  MetafieldsFilter.prototype.onClearClick = function(evt) {
    var el = evt.currentTarget;

    if (el.classList.contains('no-ajax')) {
      return;
    }

    evt.preventDefault();

    if (isAnimating || !this.sectionId) {
      return;
    }

    this.closeDrawer(false);

    var url = this.buildUrl(this.getCollectionUrl(), true);
    this.renderPage(url);
  };

  MetafieldsFilter.prototype.onFilterClick = function(evt) {
    var el = evt.currentTarget;

    if (el.classList.contains('no-ajax')) {
      return;
    }

    evt.preventDefault();

    if (isAnimating || !this.sectionId) {
      return;
    }

    this.closeDrawer(false);

    var url;

    if (el.classList.contains('metafields-filter--active')) {
      url = this.buildUrl(this.getCollectionUrl(), true);
    } else {
      url = this.buildUrl(el.getAttribute('data-filter-url'), false);
    }

    this.renderPage(url);
  };

  MetafieldsFilter.prototype.onPopState = function() {
    if (!document.querySelector(selectors.filterNav) || isAnimating) {
      return;
    }

    this.renderPage(new URL(window.location.href), false);
  };

  MetafieldsFilter.prototype.renderPage = function(url, updateHistory) {
    var self = this;

    if (typeof updateHistory === 'undefined') {
      updateHistory = true;
    }

    isAnimating = true;
    this.closeDrawer(false);
    this.startLoading();
    this.updateScroll(true);

    var fetchUrl = url.pathname + '?section_id=' + this.sectionId;

    if (url.search) {
      fetchUrl += '&' + url.search.slice(1);
    }

    return fetch(fetchUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var newDom = new DOMParser().parseFromString(html, 'text/html');
        var newContent = newDom.getElementById('CollectionAjaxContent');

        if (newContent) {
          document.getElementById('CollectionAjaxContent').innerHTML = newContent.innerHTML;
        }

        if (updateHistory) {
          history.pushState({}, '', url.pathname + url.search);
        }

        theme.sections.reinit('collection-grid');
        theme.reinitProductGridItem();
        document.dispatchEvent(new CustomEvent('collection:reloaded'));

        self.updateScroll(false);
        isAnimating = false;
      })
      .catch(function() {
        window.location.href = url.pathname + url.search;
      });
  };

  MetafieldsFilter.prototype.startLoading = function() {
    var grid = document.querySelector(selectors.collectionGrid);

    if (grid) {
      grid.classList.add('unload');
    }
  };

  MetafieldsFilter.prototype.updateScroll = function(animate) {
    var scrollToElement = document.querySelector(selectors.scrollTarget);
    var scrollTo = scrollToElement && scrollToElement.offsetTop;

    if (!theme.config.bpSmall && scrollTo) {
      scrollTo -= 15;
    }

    if (theme.config.stickyHeader && scrollTo) {
      var header = document.querySelector('.site-header');

      if (header) {
        scrollTo -= header.offsetHeight;
      }
    }

    if (!scrollTo) {
      return;
    }

    if (animate) {
      window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: scrollTo });
    }
  };

  function init() {
    document.querySelectorAll(selectors.filterNav).forEach(function(nav) {
      new MetafieldsFilter(nav);
    });
  }

  return {
    init: init
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  theme.MetafieldsFilter.init();
});

document.addEventListener('collection:reloaded', function() {
  theme.MetafieldsFilter.init();
});
